import { fetchFactory } from 'isotope-client'

export const getConfiguration = () => fetchFactory('/configuration', {}, '/api/public')
